import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Loading from './Loading';

const ProtectedRoute = ({ allowedRoles, children }) => {
  const { user, role, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <Loading />;
  }

  if (!user) {
    if (location.pathname.toLowerCase().startsWith('/demo')) {
      return <Navigate to="/login?account=demo" replace />;
    }
    return <Navigate to="/login" replace />;
  }

  // Forced new student password update lock removed to support voluntary password settings

  if (allowedRoles && !allowedRoles.includes(role)) {
    let dashboardPath = '/login';
    if (role === 'admin') dashboardPath = '/admin/dashboard';
    else if (role === 'employee' || role === 'teacher') dashboardPath = '/employee/dashboard';
    else if (role === 'student') dashboardPath = '/student/dashboard';
    else if (role === 'demo_student') dashboardPath = '/demo/dashboard';

    return (
      <div style={{ 
        display: 'flex', 
        height: '100vh', 
        width: '100vw',
        justifyContent: 'center', 
        alignItems: 'center', 
        backgroundColor: 'var(--bg-base)',
        fontFamily: 'var(--font-sans)',
        padding: '24px'
      }}>
        <div style={{ 
          backgroundColor: 'var(--bg-surface)',
          border: '1px solid var(--border)',
          borderRadius: 'var(--radius-lg)',
          boxShadow: 'var(--shadow-lg)',
          textAlign: 'center', 
          maxWidth: '400px', 
          width: '100%',
          padding: '32px' 
        }}>
          <h2 style={{ color: 'var(--primary)', marginBottom: '12px', fontSize: '1.5rem', fontWeight: 800 }}>Access Denied</h2>
          <p style={{ color: 'var(--text-body)', marginBottom: '24px', fontSize: '0.9rem', lineHeight: '1.5' }}>
            You do not have permissions to access this page.
          </p>
          <a href={dashboardPath} className="btn btn-primary" style={{ display: 'block', width: '100%', textDecoration: 'none' }}>
            Go to My Dashboard
          </a>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
